import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/logo-small.png'


const _hoisted_1 = {
  class: "font-weight-light text-custom_color_18",
  style: {"margin-left":"6px"}
}
const _hoisted_2 = { class: "font-weight-light text-custom_color_18" }
const _hoisted_3 = {
  key: 2,
  style: {"padding-top":"10px","margin-left":"5px","margin-right":"5px"},
  class: "d-flex align-center border-t-sm border-b-sm pl-4 mt-2 mb-2 pb-3"
}
const _hoisted_4 = {
  key: 7,
  class: "d-flex align-center"
}

import { useAuthStore } from '@/stores/useAuthStore'
import { useDisplay, useTheme } from 'vuetify'
import { computed, nextTick, ref, useTemplateRef } from 'vue'
import useNavigations from '@/components/navigations/composables/useNavigations'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigation',
  setup(__props) {

const theme = useTheme()

const storeAuth = useAuthStore()

const isSearchActive = ref(false)
const searchString = ref('')
const search = useTemplateRef<HTMLInputElement>('search')
const isFocus = ref(false)
const isOpen = ref(false)

const { navigations } = useNavigations()
const { width } = useDisplay()

function toggleSearch() {
    isSearchActive.value = !isSearchActive.value
    if (isSearchActive.value) {
        nextTick(() => {
            if (search.value) search.value.focus()
        })
    } else {
        searchString.value = ''
    }
}

const isLive = process.env.VUE_APP_ENV === 'master'

const isMobile = computed(() => width.value < 768)

function searchAction() {
    if (searchString.value.length) location.href = getCoPageURL(`/GlobalSearch?searchText=${searchString.value}`)
}

function getCoPageURL(path: string) {
    return `${process.env.VUE_APP_CO_BASE_URL}${path}`
}

function toggleTheme() {
    theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark'
}

return (_ctx: any,_cache: any) => {
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_unref(storeAuth).isAuth)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        density: "compact",
        absolute: "",
        flat: "",
        color: isLive ? 'white' : 'staging',
        class: _normalizeClass(["border-sm border-opacity-100 flex-wrap position-relative", isLive ? 'border-custom_color_28' : 'border-white']),
        border: "surface",
        style: _normalizeStyle(`padding-right: ${isMobile.value ? '0' : '15'}px; border-radius: 4px; min-height: ${
            isLive ? '52' : '53.5'
        }px;`)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex flex-grow-1 flex-wrap", isMobile.value ? 'flex-column align-start justify-start' : 'align-center justify-space-between'])
          }, [
            _createVNode(_component_v_btn, {
              href: getCoPageURL('/home'),
              variant: "text",
              class: _normalizeClass(["pa-0", {
                    'mt-1': isMobile.value,
                    'border-t-sm': isMobile.value,
                    'border-white': isLive,
                }]),
              height: "40",
              style: {"margin-left":"15px","margin-bottom":"2px","margin-top":"1px"},
              "base-color": "transparent"
            }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  style: {"height":"40px"},
                  class: "mr-2"
                }, null, -1)),
                _createVNode(_component_v_hover, null, {
                  default: _withCtx(({ isHovering, props }) => [
                    _createElementVNode("div", _mergeProps(props, {
                      style: {"font-size":"18px","margin-left":"-0.3px","font-weight":"500"},
                      class: ["text-capitalize", [
                            isLive
                                ? isHovering
                                    ? 'text-primary'
                                    : 'text-custom_color_18'
                                : isHovering
                                ? 'text-primary'
                                : 'text-white',
                        ]]
                    }), " Channel Optimiser ", 16)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["href", "class"]),
            _createVNode(_component_v_spacer),
            (isMobile.value)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value)),
                  "min-width": "44",
                  width: "44",
                  "max-width": "44",
                  height: "34",
                  "min-height": "34",
                  color: "custom_color_45",
                  variant: isFocus.value ? 'flat' : 'outlined',
                  ripple: false,
                  onFocus: _cache[1] || (_cache[1] = ($event: any) => (isFocus.value = true)),
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (isFocus.value = false)),
                  style: {"right":"-1px"},
                  class: "position-absolute top-0 mt-2 mr-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "custom_color_44",
                      size: "30",
                      icon: "mdi-menu"
                    })
                  ]),
                  _: 1
                }, 8, ["variant"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              style: _normalizeStyle(
                    isOpen.value || !isMobile.value
                        ? 'max-height: 1000px;transition: all 0.6s'
                        : 'max-height: 0;transition: all 0.6s'
                ),
              class: _normalizeClass(["overflow-hidden d-flex", { 'w-100': isMobile.value }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["d-flex flex-wrap", isMobile.value ? 'flex-column border-t-sm w-100 mt-1 pt-1' : 'ml-auto align-center']),
                style: _normalizeStyle(isMobile.value && 'min-height: 560px; margin-bottom: -22px')
              }, [
                (isMobile.value)
                  ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                      key: 0,
                      variant: "accordion",
                      rounded: "0",
                      "collapse-icon": "",
                      "expand-icon": "",
                      "bg-color": "transparent",
                      flat: "",
                      class: "hide-expansion-icon mt-1",
                      ripple: false
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigations), (navigation) => {
                          return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                            key: navigation.title,
                            color: "transparent",
                            height: "40",
                            "min-height": "40",
                            "max-height": "40"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panel_title, { class: "pa-0" }, {
                                default: _withCtx(({ expanded }) => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["d-flex flex-grow-1 h-100 align-center text-body-1", { 'text-primary': expanded, 'bg-white': expanded }]),
                                    style: {"padding-left":"15px"}
                                  }, [
                                    _createVNode(_component_v_sheet, {
                                      color: "transparent",
                                      class: "d-flex align-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: _normalizeClass([
                                                    isLive
                                                        ? expanded
                                                            ? 'text-primary'
                                                            : 'text-custom_color_18'
                                                        : 'opacity-100'
                                                , "font-weight-light"]),
                                          style: {"letter-spacing":"0"}
                                        }, _toDisplayString(navigation.title), 3)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_icon, {
                                      size: "12",
                                      class: "ml-1",
                                      icon: "custom:icon-caret-down",
                                      color: isLive ? (expanded ? 'text-primary' : 'custom_color_18') : '',
                                      style: {"margin-top":"1px"}
                                    }, null, 8, ["color"])
                                  ], 2)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_expansion_panel_text, { class: "pa-0" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_list, {
                                    density: "comfortable",
                                    class: "text-capitalize pb-2 rounded-t-0",
                                    border: 
                                            isLive || isMobile.value ? `primary opacity-100 t-sm` : `silver opacity-100 t-sm`
                                        
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.children, (child) => {
                                        return (_openBlock(), _createBlock(_component_v_list_item, {
                                          key: child.title,
                                          href: child.path && getCoPageURL(child.path),
                                          to: child.name && { name: child.name, query: child.query },
                                          class: "mt-n2 mb-n2",
                                          "min-height": "38"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_1, _toDisplayString(child.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["href", "to"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["border"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(navigations), (navigation) => {
                      return (_openBlock(), _createBlock(_component_v_menu, {
                        key: navigation.title,
                        "open-on-hover": "",
                        "open-on-click": false,
                        "open-on-focus": false,
                        "open-delay": "50",
                        "close-delay": "25",
                        location: "bottom right",
                        transition: "false"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps({
                            class: ["text-capitalize text-subtitle-1 opacity-100", {
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile.value,
                                }],
                            variant: "plain",
                            ripple: false,
                            rounded: 0
                          }, { ref_for: true }, props, {
                            height: isMobile.value ? 41 : isLive ? 52 : 54,
                            style: {"margin-top":"-1px","padding-left":"13.25px","padding-right":"13.25px"}
                          }), {
                            default: _withCtx(() => [
                              _createVNode(_component_v_hover, null, {
                                default: _withCtx(({ isHovering, props }) => [
                                  _createVNode(_component_v_sheet, _mergeProps({ ref_for: true }, props, {
                                    height: "50",
                                    color: "transparent",
                                    class: "d-flex align-center"
                                  }), {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass([
                                                isLive
                                                    ? isHovering
                                                        ? 'text-primary'
                                                        : 'text-custom_color_18'
                                                    : 'opacity-100'
                                            , "font-weight-light"]),
                                        style: {"letter-spacing":"0"}
                                      }, _toDisplayString(navigation.title), 3)
                                    ]),
                                    _: 2
                                  }, 1040),
                                  _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, props, {
                                    size: "12",
                                    class: "ml-1",
                                    icon: "custom:icon-caret-down",
                                    color: isLive ? (isHovering ? 'text-primary' : 'custom_color_18') : '',
                                    style: {"margin-top":"1px"}
                                  }), null, 16, ["color"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1040, ["class", "height"])
                        ]),
                        default: _withCtx(() => [
                          (navigation.children.length)
                            ? (_openBlock(), _createBlock(_component_v_list, {
                                key: 0,
                                density: "comfortable",
                                class: "text-capitalize pb-2 rounded-t-0",
                                rounded: "8",
                                border: isLive || isMobile.value ? `silver opacity-100 t-sm` : `silver opacity-100 t-sm`,
                                style: _normalizeStyle(isMobile.value ? 'margin-left: -12px' : 'margin-top: -1px;')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.children, (child) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: child.title,
                                      href: child.path && getCoPageURL(child.path),
                                      to: child.name && { name: child.name, query: child.query },
                                      "base-color": "white",
                                      "active-class": "text-text-custom_color_18 opacity-100",
                                      class: "mt-n2 mb-n2",
                                      "min-height": "38"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_2, _toDisplayString(child.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["href", "to"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["border", "style"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                (_unref(storeAuth).isUserHasRole(['GlobalSearch']) && isMobile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_btn, {
                        onClick: toggleSearch,
                        density: "compact",
                        variant: isLive ? 'outlined' : 'flat',
                        rounded: "circle",
                        "min-width": "33",
                        width: "33",
                        color: isLive ? 'silver' : '',
                        height: "31",
                        class: "pa-0",
                        style: _normalizeStyle(isLive ? `margin-top: 1px` : `margin-top: 2px`)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "black",
                            icon: "custom:icon-search-font"
                          })
                        ]),
                        _: 1
                      }, 8, ["variant", "color", "style"]),
                      _withDirectives(_createVNode(_component_v_text_field, {
                        modelValue: searchString.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchString).value = $event)),
                        class: "ml-2 mr-2",
                        density: "default",
                        variant: "outlined",
                        "bg-color": "white",
                        color: "primary",
                        ref_key: "search",
                        ref: search,
                        "hide-details": "",
                        "single-line": "",
                        onBlur: toggleSearch,
                        onKeyup: _withKeys(searchAction, ["enter"]),
                        "aria-controls": "false",
                        rounded: "",
                        flat: "",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"]), [
                        [_vShow, isSearchActive.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_menu, {
                  "open-on-hover": "",
                  "open-delay": "0",
                  location: "bottom right"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({
                      class: ["text-capitalize text-subtitle-1 opacity-100", {
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile.value,
                                }],
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(storeAuth).logout())),
                      style: 
                                    isLive
                                        ? `margin-left: -3px; margin-bottom: 2px`
                                        : `margin-left: -3px; margin-bottom: 1px`
                                ,
                      variant: "plain",
                      rounded: 0
                    }, props, {
                      height: isMobile.value ? 39 : isLive ? '100%' : '52',
                      color: isLive ? 'custom_color_18' : ''
                    }), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_hover, null, {
                          default: _withCtx(({ isHovering, props }) => [
                            _createElementVNode("span", _mergeProps({
                              class: isHovering ? 'text-primary' : ''
                            }, props), "Logout", 16)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1040, ["class", "style", "height", "color"])
                  ]),
                  _: 1
                }),
                (_unref(storeAuth).isUserHasRole(['Web_Nav_Support']))
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 3,
                      "open-on-hover": "",
                      "open-delay": "0",
                      location: "bottom right"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: ["text-capitalize text-subtitle-1 opacity-100", {
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile.value,
                                }],
                          "min-width": "38",
                          to: { name: 'support' },
                          style: 
                                    isLive
                                        ? `margin-right: -2px; margin-left: -4px; margin-bottom: 2px`
                                        : `margin-right: -2px; margin-left: -4px; margin-bottom: 1px`
                                ,
                          variant: "plain",
                          rounded: 0
                        }, props, {
                          height: isMobile.value ? 39 : isLive ? '100%' : '52',
                          color: isLive ? 'custom_color_18' : ''
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_hover, null, {
                              default: _withCtx(({ isHovering, props }) => [
                                (isMobile.value)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode("Help")
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _mergeProps({
                                  class: isHovering ? 'text-primary' : ''
                                }, props), "?", 16)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1040, ["class", "style", "height", "color"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(storeAuth).isUserHasRole(['Web_Nav_Admin_importexportmgt']))
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 4,
                      "open-on-hover": "",
                      "open-delay": "0",
                      location: "bottom right"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: ["text-capitalize text-subtitle-1 opacity-100", {
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile.value,
                                }],
                          "min-width": "46",
                          to: { name: 'import.data.sheets' },
                          href: getCoPageURL('/ImportCenter'),
                          style: 
                                    isLive
                                        ? `padding-bottom: 2px; margin-right: -2px; margin-bottom: 2px`
                                        : `padding-bottom: 2px; margin-right: -2px; margin-bottom: 1px`
                                ,
                          variant: "plain",
                          rounded: 0
                        }, props, {
                          height: isMobile.value ? 39 : isLive ? '100%' : '52'
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_hover, null, {
                              default: _withCtx(({ isHovering, props }) => [
                                _createVNode(_component_v_icon, _mergeProps(props, {
                                  color: isLive ? (isHovering ? 'text-primary' : 'custom_color_18') : '',
                                  size: "16",
                                  icon: "custom:icon-arrow-circle-up"
                                }), null, 16, ["color"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1040, ["href", "class", "style", "height"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(storeAuth).isUserHasRole(['COBI_Access']))
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 5,
                      "open-on-hover": "",
                      "open-delay": "0",
                      location: "bottom right"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({
                          class: ["text-capitalize text-subtitle-1 opacity-100", {
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile.value,
                                    'mb-4': isMobile.value,
                                    'mr-n4': !(_unref(storeAuth).isUserHasRole(['GlobalSearch']) && !isMobile.value),
                                }],
                          "min-width": "50",
                          href: getCoPageURL('/Pulse'),
                          style: 
                                    isLive
                                        ? `padding-bottom: 2px; margin-right: 14px; margin-bottom: 2px`
                                        : `padding-bottom: 2px; margin-right: 14px; margin-bottom: 1px`
                                ,
                          variant: "plain",
                          rounded: 0
                        }, props, {
                          height: isMobile.value ? 39 : isLive ? '100%' : '52'
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_hover, null, {
                              default: _withCtx(({ isHovering, props }) => [
                                _createVNode(_component_v_icon, _mergeProps(props, {
                                  color: isLive ? (isHovering ? 'text-primary' : 'custom_color_18') : '',
                                  size: "20",
                                  icon: "custom:icon-wave-square"
                                }), null, 16, ["color"]),
                                (isMobile.value)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["ml-1", { 'text-custom_color_18': isLive }])
                                    }, " Alerts ", 2))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1040, ["href", "class", "style", "height"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 6,
                      onClick: toggleTheme,
                      icon: 'mdi-theme-light-dark',
                      variant: "text"
                    }))
                  : _createCommentVNode("", true),
                (_unref(storeAuth).isUserHasRole(['GlobalSearch']) && !isMobile.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_v_btn, {
                        onClick: toggleSearch,
                        density: "compact",
                        variant: isLive ? 'outlined' : 'flat',
                        rounded: "circle",
                        "min-width": "33",
                        width: "33",
                        color: isLive ? 'silver' : '',
                        height: "31",
                        class: "pa-0",
                        style: _normalizeStyle(isLive ? `margin-top: 1px` : `margin-top: 2px`)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            color: "black",
                            icon: "custom:icon-search-font"
                          })
                        ]),
                        _: 1
                      }, 8, ["variant", "color", "style"]),
                      _withDirectives(_createVNode(_component_v_text_field, {
                        modelValue: searchString.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchString).value = $event)),
                        class: "ml-2",
                        "max-width": "180",
                        width: "180",
                        density: "default",
                        variant: "outlined",
                        "bg-color": "white",
                        color: "primary",
                        ref_key: "search",
                        ref: search,
                        "hide-details": "",
                        "single-line": "",
                        onBlur: toggleSearch,
                        onKeyup: _withKeys(searchAction, ["enter"]),
                        "aria-controls": "false",
                        rounded: "",
                        flat: "",
                        autocomplete: "off"
                      }, null, 8, ["modelValue"]), [
                        [_vShow, isSearchActive.value]
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 6)
            ], 6)
          ], 2)
        ]),
        _: 1
      }, 8, ["color", "class", "style"]))
    : _createCommentVNode("", true)
}
}

})